import React, { createContext, useContext } from 'react';
var TabIndexContextValue = /*#__PURE__*/createContext(null);
function TabIndexContext(_ref) {
  var disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(TabIndexContextValue.Provider, {
    value: disabled
  }, children);
}
function useTabIndexContext() {
  var isTabIndexDisabled = useContext(TabIndexContextValue);
  if (isTabIndexDisabled === null) {
    return undefined;
  }
  return isTabIndexDisabled ? -1 : 0;
}
export { useTabIndexContext };
export default TabIndexContext;